import Request from './http'
import type { InternalAxiosRequestConfig, AxiosResponse } from 'axios'
import { toast } from 'vue-sonner'
import { useUserStore } from '@/stores'
import i18n from '@/locales'

/**
 * 默认配置的请求实例
 */
const request = new Request({
  // 使用环境变量配置 baseURL
  // baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000,
  interceptors: {
    // 请求拦截器
    requestInterceptors: (config: InternalAxiosRequestConfig) => {
      // 添加token
      const user = localStorage.getItem('user')
      const { userInfo } = JSON.parse(user || '{}')
      if (userInfo?.token) {
        config.headers.Authorization = `Bearer ${userInfo.token}`
      }
      if (!(config.data instanceof FormData)) {
        // 设置请求头为 application/json
        config.headers['Content-Type'] = 'application/json'
      }

      return config
    },
    // 响应拦截器
    responseInterceptors: (response: AxiosResponse) => {
      // 注意：全局响应拦截器（在 src/service/http/index.ts 中）已经配置了 return res.data
      // 实例拦截器执行顺序通常在全局拦截器之前（取决于实现），
      // 但为了配合全局拦截器的统一解包逻辑，这里建议直接返回 response，
      // 让全局拦截器去处理 data 的解构，否则可能导致二次解构得到 undefined。

      // 这里是成功请求后的错误提示处理，权限相关后端code为0表示请求成功
      if (response.data.code !== 0) {
        toastError(response)
      }
      // 统一处理登录过期
      if (response.data.code == 10011) {
        toastError(response)
        // 清除本地存储的用户信息
        localStorage.removeItem('user')

        const userStore = useUserStore()
        userStore.logout()
        // TODO 处理登录？
        // userStore.setLoginOpen(true)
      }
      return response
    },
  },
})

const toastError = (response: AxiosResponse) => {
  toast.error(serverMessage(response.data.code, response.data.msg))
}

export const serverMessage = (code: number, msg: string) => {
  const { te, t } = i18n.global
  const key = `server.${code}`
  return te(key) ? t(key) : msg
}

export default request
